import React from 'react';
import FrameMessenger from 'frame-messenger';
import { GWITracker } from 'gwi-tracker';
import PropTypes from 'prop-types';
import logger from '../../shared/helpers/logger';
import BrickPoster from './brick-poster';
import BrickMetadata from './brick-metadata';
import JsonpApi from '../../shared/helpers/jsonp-api';

class Brick extends React.Component {

  static propTypes = {
    /*eslint-disable */
    brickData: PropTypes.object.isRequired,
    /*eslint-enable */
  };

  state = {
    brickData: this.props.brickData,
  };

  componentWillMount() {
    const brickData = this.state.brickData;
    const hasAuthToken = !!brickData.api.authToken;
    const { isModalBrick, fireBrickImpression } = brickData;

    if (!hasAuthToken) {
      this.fetchAuthTokenAndRefresh();
    }

    this.setFrameHandlers();

    if (!isModalBrick && fireBrickImpression !== false) {
      GWITracker.trackBrickImpression(brickData.trackingState);
    } else {
      logger.debug('Will NOT fire brick impression.');
    }
  }

  onRate = (rating) => {
    logger.debug('onRate is called with rating:', rating);
    const brickData = this.state.brickData;
    brickData.userRating = rating;

    this.setState({ brickData });
  };

  onQueue = () => {
    const brickData = this.state.brickData;
    brickData.inQueue = !this.state.brickData.inQueue;

    this.setState({ brickData });
  };

  onListMenuOpen = (lists) => {
    const brickData = this.state.brickData;
    brickData.userLists = lists;

    this.setState({ brickData });
  };

  onErasedRating = () => {
    const brickData = this.state.brickData;
    brickData.userRating = null;

    this.setState({ brickData });
  };

  onCTAClick = () => {
    const brickData = this.state.brickData;

    if (this.state.brickData.listId) {
      GWITracker.trackListItemClick(brickData.trackingState);
    } else {
      GWITracker.trackCallToActionClick(brickData.trackingState);
    }
  };

  setFrameHandlers = () => {
    const frameMessenger = new FrameMessenger('*');

    /* eslint-disable no-unused-vars */
    frameMessenger.receive('sign-in-state-changed', (frameName, data) => {
      this.fetchAuthTokenAndRefresh();
    });
    /* eslint-enable no-unused-vars */
  };

  setUserRating = (rating) => {
    const brickData = this.state.brickData;

    brickData.ratingFound = true;

    if (rating) {
      brickData.hasUserRated = true;
      brickData.userRating = rating;
    }

    this.setState({ brickData });
  };

  fetchAuthTokenAndRefresh() {
    const brickData = this.state.brickData;
    const { api, watchableType, watchableId } = brickData;

    // If the user is logged into the GoWatchIt system,
    // then we want to display their lists and whether
    // or not this watchable is in their queue.
    // However, on first load we do not have access to the auth token.
    // This fetches the auth token of the logged in user, refetches the data,
    // and subsequently rerenders the brick so it has up-to-date queue and list data.
    const jsonpApi = new JsonpApi(api.apiKey, api.authToken, api.gwiHost);

    jsonpApi.getUserAuthToken().then((response) => {
      api.authToken = response.authentication_token;

      // If there is an authToken, then refetch the data.
      if (api.authToken) {
        api.getBrick(watchableType, watchableId).then((resp) => {
          brickData.updateFromLoginResponse(resp.bricks[0]);

          this.setState({ brickData });
        });
      }
    });
  }

  render() {
    const isModalBrickClass = (this.props.brickData.isModalBrick ? ' modal-brick' : '');

    return (
      <div className={`gwi-brick--root${isModalBrickClass}`}>
        <div className="gwi-brick--brick-holder">
          <div className="gwi-brick--brick">
            <BrickPoster
              brickData={this.state.brickData}
              onRate={this.onRate}
              onQueue={this.onQueue}
              onListMenuOpen={this.onListMenuOpen}
              onErasedRating={this.onErasedRating}
              onCTAClick={this.onCTAClick}
            />
            { BrickMetadata({
              hideUserActions: this.state.brickData.hideUserActions,
              watchUrl: this.state.brickData.watchUrl,
              title: this.state.brickData.title,
              year: this.state.brickData.year,
              numberOfQueues: this.state.brickData.numberOfQueues,
              onCTAClick: this.onCTAClick,
            }) }
          </div>
        </div>
      </div>
    );
  }
}

export default Brick;



// WEBPACK FOOTER //
// ./src/client/components/brick.jsx